var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoThumbnailSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 25V18.995C100.001 18.4702 99.8978 17.9504 99.6972 17.4654C99.4967 16.9804 99.2025 16.5397 98.8314 16.1686C98.4603 15.7975 98.0196 15.5033 97.5346 15.3028C97.0496 15.1022 96.5298 14.9993 96.005 15H4.005C3.47972 14.9993 2.95944 15.1022 2.47389 15.3026C1.98833 15.503 1.54701 15.7971 1.17511 16.168C0.803212 16.539 0.508023 16.9796 0.306398 17.4646C0.104772 17.9497 0.000659328 18.4697 3.1292e-06 18.995V25H10V35H3.1292e-06V45H10V55H3.1292e-06V65H10V75H3.1292e-06V80.995C-0.000654944 81.5211 0.102488 82.0422 0.303525 82.5284C0.504562 83.0146 0.799543 83.4564 1.17157 83.8284C1.5436 84.2005 1.98537 84.4954 2.47158 84.6965C2.95778 84.8975 3.47887 85.0007 4.005 85H96.005C96.5303 84.9994 97.0503 84.8952 97.5354 84.6936C98.0204 84.492 98.461 84.1968 98.832 83.8249C99.2029 83.453 99.497 83.0117 99.6974 82.5261C99.8978 82.0406 100.001 81.5203 100 80.995V75H90V65H100V55H90V45H100V35H90V25H100ZM40 65V35L65 50L40 65Z",
    fill: "url(#paint0_linear_958_1306)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_958_1306",
    x1: 50,
    y1: 15,
    x2: 50,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146FE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_1306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoThumbnailSvg);
export default __webpack_public_path__ + "static/media/VideoThumbnailSvg.fa42dc995fe2b73ee9151e1f97747cf7.svg";
export { ForwardRef as ReactComponent };